<div class="info-wrapper">
  <div class="info">
    <p i18n>From</p>
    <p class="">
      <strong class="t-medium">{{
        tour.pricing.student
          | unCurrency : tour.currency : (fx.baseCurrency$ | async)
      }}</strong>
      <span class="m-l-8" i18n>per person</span>
    </p>
  </div>
</div>
<div class="divider"></div>
@if (!auth.isLoggedIn || auth.isStudent || auth.isAgencyUser) {
<un-button (btnClick)="book.emit()" type="primary" size="large" i18n
  >Book Now</un-button
>
} @else {
<un-button
  [link]="[RoutePath.dashboardTours, tour._id, RoutePath.edit]"
  type="primary"
  size="large"
  i18n
  >Edit</un-button
>
}
